import { useState, UIEvent, HTMLProps } from 'react';

import { Image } from '@grupoboticario/flora-react';

import placeholderImg from '/public/images/placeholder.jpg';

const ProductImage = ({ src, alt = '', ...props }: Omit<HTMLProps<HTMLImageElement>, 'as'>) => {
  const [imageSource, setImageSource] = useState<string | undefined>(src);

  const onError = ({ currentTarget }: UIEvent<HTMLImageElement>) => {
    currentTarget.onerror = null;
    setImageSource(placeholderImg);
  };

  return <Image src={imageSource} alt={alt} onError={onError} {...props} />;
};

export default ProductImage;
